import { render, staticRenderFns } from "./FlowObjectStarter.vue?vue&type=template&id=0f5fa076&scoped=true"
import script from "./FlowObjectStarter.vue?vue&type=script&lang=js"
export * from "./FlowObjectStarter.vue?vue&type=script&lang=js"
import style0 from "./FlowObjectStarter.vue?vue&type=style&index=0&id=0f5fa076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5fa076",
  null
  
)

export default component.exports